import ngAnnotate from '../ngAnnotate.macro';

const adminRoutes = ($routeProvider: ng.route.IRouteProvider) => {
  $routeProvider
    .when('/admin/dashboard', {
      template: '<bb-admin-dashboard />',
      reloadOnSearch: false,
    })
    .when('/admin/answering', {
      template: '<bb-admin-answering />',
      reloadOnSearch: false,
    });
};

ngAnnotate(adminRoutes);

angular.module('bb.admin').config(adminRoutes);
